import { Package } from './Package';
import { ECustomDataPackageType } from '../../slices/customDataSlice';
import { IPackage, TParams } from './types';
import { CustomPackage } from './CustomPackage';
import { Subscription } from './Subscription';

export const createPackage = (packageType: ECustomDataPackageType): IPackage<TParams> => {
  switch (packageType) {
    case ECustomDataPackageType.Package: {
      return new Package();
    }

    case ECustomDataPackageType.CustomPackage: {
      return new CustomPackage();
    }

    case ECustomDataPackageType.Subscription: {
      return new Subscription();
    }
  }
};
